module.exports = "/_next/static/media/upgrade-button-static.f7b61457.png";